import { checkbox } from '@utils/validation';
import { z } from 'zod';

export const testContent = {
	pageHeader: `I'm a header`,
	pageInfo: 'This is my page, my home sweet home',
	medicationHeader: 'Here are your choices',
	spironolactone: {
		title: 'Title',
		description: 'Description',
	},
	finasteride: {
		title: 'Title',
		description: 'Description',
	},
	dutasteride: {
		title: 'Title',
		description: 'Description',
	},
	progesterone: {
		title: 'Title',
		description: 'Description',
	},
	unsure: {
		title: 'Title',
		description: 'Description',
	},
};

export const schema = z.object({
	spironolactone: checkbox,
	finasteride: checkbox,
	dutasteride: checkbox,
	progesterone: checkbox,
	unsure: checkbox,
});
